import { itemdimensionanalysisConstant } from "../constants/ItemDimensionAnalysisConstants";

export function item(state= {}, action){
    
    switch(action.type) {
        case itemdimensionanalysisConstant.GET_ITEM_DETAILS_REQUEST:
            return{ ...state, loading: true,};
        case itemdimensionanalysisConstant.GET_ITEM_DETAILS_SUCCESS:

            return{ ...state, item: action?.item?.data};
 
        case itemdimensionanalysisConstant.GET_ITEM_DETAILS_FAILURE:
            return{ ...state, loading: false, };
        
        case itemdimensionanalysisConstant.GET_ITEM_SUMMARY_REQUEST:
            return{ ...state, loading: true,};
        case itemdimensionanalysisConstant.GET_ITEM_SUMMARY_SUCCESS:

            return{ ...state, itemSummary: action?.item?.data};
 
        case itemdimensionanalysisConstant.GET_ITEM_SUMMARY_FAILURE:
            return{ ...state, loading: false, };
                    
        case itemdimensionanalysisConstant.RESET_API_MESSAGES: 
        return{
            ...state,
            itemSuccessMessage: undefined,
            itemErrorMessage: undefined,
        };
        case itemdimensionanalysisConstant.RESET_ITEM_DETAILS:
            return{
                ...state,
                item: undefined,
                itemSummary: undefined,
                itemSuccessMessage: undefined,
                itemErrorMessage: undefined,
            };
        default:
            return state;
}
}